import { jsx as _jsx } from "react/jsx-runtime";
import CompleteIcon from "@mui/icons-material/CheckCircleOutline";
import IncompleteIcon from "@mui/icons-material/ErrorOutline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
import { useAttributeGroup } from "./useAttributeGroup";
export function AttributeGroupCompletenessIndicator(props) {
    const { groupId, groupBehavior } = props;
    const { isGroupComplete } = useAttributeGroup({ groupId, groupBehavior });
    return (_jsx(AttributeGroupCompletenessIndicatorUi, { groupId: groupId, isComplete: isGroupComplete }));
}
function AttributeGroupCompletenessIndicatorUi(props) {
    const { isComplete } = props;
    const t = useUiTranslator();
    const title = isComplete
        ? t("ConfigurationRenderer:AttributeGroup.complete", "Attribute group is complete")
        : t("ConfigurationRenderer:AttributeGroup.notComplete", "Attribute group is not complete");
    const icon = isComplete ? (_jsx(CompleteIcon, { color: "inherit" })) : (_jsx(IncompleteIcon, { color: "inherit" }));
    function handleClick(e) {
        // prevents accordion from closing
        e.preventDefault();
        e.stopPropagation();
    }
    return (_jsx(Tooltip, { title: title, children: _jsx(IconButton, { type: "button", onClick: handleClick, children: icon }) }));
}
//# sourceMappingURL=AttributeGroupCompletenessIndicator.js.map